import * as yup from 'yup';
export const signUpSchema = yup.object({
    email: yup.string().email('Invalid email').required('Email is required'),
    fullName: yup.string().required('Full name is required'),
    // address: yup.string().required('Address is required'),
});
